<template>
    <v-tooltip bottom class="event-notification__tooltip">
        <template v-slot:activator="{ on, attrs }">
            <div class="event-notification" v-bind="attrs" v-on="on">
                <div
                    v-if="
                        notification &&
                        isNotificationDelivered(notification.status)
                    "
                    class="event-notification__item event-notification__item-success"
                >
                    <img
                        src="@/assets/common/notifications/whatsapp.svg"
                        alt="notification-delivered"
                        class="event-notification__image"
                        :class="sizeClass"
                    />
                </div>

                <div
                    v-if="
                        notification &&
                        isNotificationNotDelivered(notification.status)
                    "
                    class="event-notification__item event-notification__item-failure"
                >
                    <img
                        src="@/assets/common/notifications/whatsapp-failure.svg"
                        alt="notification-delivered"
                        class="event-notification__image"
                        :class="sizeClass"
                    />
                </div>

                <div
                    v-if="
                        notification &&
                        isNotificationUnsent(notification.status)
                    "
                    class="event-notification__item event-notification__item-failure"
                >
                    <img
                        src="@/assets/common/notifications/whatsapp-failure.svg"
                        alt="notification-delivered"
                        class="event-notification__image"
                        :class="sizeClass"
                    />
                </div>
            </div>
        </template>
        <div class="event-notification__tooltip-content">
            <b v-if="notification">
                {{ processedData }}
            </b>
            <span
                v-if="
                    notification &&
                    notification.description &&
                    notification.status !== 'delivered'
                "
            >
                {{ handleTranslate(notification.description) }}
            </span>
        </div>
    </v-tooltip>
</template>

<script>
import {
    isNotificationDelivered,
    isNotificationNotDelivered,
    isNotificationUnsent,
} from '@/helpers/check-notification-status'

export default {
    name: 'CalendarEventNotification',
    props: {
        notification: {
            type: Object,
            default: () => {},
        },
        medium: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        processedData: function () {
            if (!this.notification) return ''

            const createdAt =
                this.notification.createdAt || this.notification.created_at
            if (!createdAt) return ''

            const date = new Date(createdAt)

            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()

            return `${day}-${month}-${year}`
        },
        sizeClass: function () {
            if (this.large) return 'event-notification__image-large'
            if (this.medium) return 'event-notification__image-medium'
            return 'event-notification__image-small'
        },
    },
    methods: {
        isNotificationNotDelivered,
        isNotificationDelivered,
        isNotificationUnsent,
        handleTranslate: function (text) {
            if (!text) return

            const processedKey = this.toKebabCase(text)

            const translatedKey = `pages.calendar.notification.${processedKey}`
            const translatedText = this.$t(translatedKey)

            if (translatedText.includes('Translation not found for key')) {
                return text
            }

            return translatedText
        },
        toKebabCase: function (text) {
            if (!text) return

            return text
                .toLowerCase()
                .replace(/[^\w\s]/gi, '')
                .replace(/\s+/g, '_')
        },
    },
}
</script>

<style lang="scss" scoped>
.event-notification {
    cursor: default;
    max-width: fit-content;
    margin: 0 auto;

    &__item {
        font-size: 10px;
        line-height: 10px;
        padding: 0 4px;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        align-items: center;
        gap: 2px;
        background: transparent;
    }

    &__image {
        width: 18px;
        aspect-ratio: 1;
    }

    &__image-medium {
        width: 24px;
        aspect-ratio: 1;
    }

    &__image-large {
        width: 32px;
        aspect-ratio: 1;
    }

    &__tooltip-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
}

.v-tooltip__content {
    max-width: 300px;
    background-color: #fff;
    color: #000;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 12px;
    line-height: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.v-tooltip__arrow {
    border-top-color: #2a3b52;
}
</style>
